'use client';

import { useEffect } from 'react';
import Link from 'next/link';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('Page error:', error);
  }, [error]);

  return (
    <div className="mx-auto w-full max-w-[1440px] px-3 pt-8 pb-16 sm:px-6 sm:pt-12 lg:px-8">
      <div className="max-w-3xl">
        <h1 className="text-2xl font-semibold tracking-tight text-slate-950 sm:text-3xl">
          Something went wrong
        </h1>
        <p className="mt-2 text-sm leading-6 text-slate-600 sm:text-base">
          We hit an unexpected error. Try refreshing, or browse our catalog.
        </p>
        <div className="mt-6 flex flex-col gap-3 sm:flex-row">
          <button
            type="button"
            onClick={reset}
            className="inline-flex min-h-11 items-center justify-center rounded-md bg-blue-700 px-4 text-sm font-semibold text-white transition-colors hover:bg-blue-800"
          >
            Try again
          </button>
          <Link
            href="/browse"
            className="inline-flex min-h-11 items-center justify-center rounded-md border border-slate-300 bg-white px-4 text-sm font-semibold text-slate-800 transition-colors hover:bg-slate-50"
          >
            Browse devices
          </Link>
        </div>
      </div>
    </div>
  );
}
